import React from 'react'
import { useSwiperSlide } from 'swiper/react'
import { Link } from 'react-router-dom'

function ProjectSlide({ data, onClick }) {
    const swiperSlide = useSwiperSlide()
    return (
        <Link to={`/project/${data.name}`} data-active={swiperSlide.isActive ? 'active' : 'no-active'} data-title={data.name} onClick={onClick}>
            <section className="projects">
                <img src="/dummy.png" alt="menfesskuy-projec-img" />
                <div className="project-slide-name">
                    <h1>{data.name}</h1>
                </div>
            </section>
        </Link>
    )
}

export default ProjectSlide